<template>

    <main class="infomaterialien">

        <header class="page-header">
            <div class="heading-container">
                <div class="heading-container-inner">
                    <div class="image-container d-none d-sm-block"
                         v-bind:style="{ backgroundImage : 'url(' + (page['acf']['desktop_image'] ? page['acf']['desktop_image'] : '/img/page-banner.png') + ')' }"></div>
                    <div class="image-container d-block d-sm-none"
                         v-bind:style="{ backgroundImage : 'url(' + (page['acf']['mobile_image'] ? page['acf']['desktop_image'] : '/img/page-banner.png') + ')' }"></div>
                    <div class="overlay"></div>
                    <h1 class="heading text-uppercase"
                        v-html="page['acf']['heading'] ? page['acf']['heading'] : page.title['rendered']"></h1>
                </div>
                <div class="image-copyright-text" v-if="page['acf']['image_copyright_text']" v-html="'&copy; ' + page['acf']['image_copyright_text']"></div>
            </div>
            <div class="container-fluid"
                 v-if="(page['acf']['sub_heading'] || page['acf']['short_text']) && showContactForm === false">
                <div class="page-details">
                    <h2 class="sub-heading" v-if="page['acf']['sub_heading']" v-html="page['acf']['sub_heading']"></h2>
                    <div class="short-text mb-0" v-if="page['acf']['short_text']" v-html="page['acf']['short_text']"></div>
                    <a @click='loadContactForm("")' class="btn btn-pink-white ani-btn-hover-scale-bounce mt-4">Zum
                        Bestellformular<i class="arrow arrow-right"></i></a>
                </div>
            </div>
        </header>

        <div class="infomaterial-container" v-if="page['acf']['infomaterial'] && showContactForm === false">
            <div class="container-fluid">
                <div class="infomaterial-inner">
                    <div class="infomaterial-item" v-for="infomaterial in page['acf']['infomaterial']">
                        <div class="infomaterial-item-thumbnail-container">
                            <img
                                v-if="infomaterial.infomaterial_item.infomaterial_item_thumbnail"
                                :alt="infomaterial.infomaterial_item.infomaterial_item_title"
                                class="infomaterial-item-thumbnail"
                                :src="infomaterial.infomaterial_item.infomaterial_item_thumbnail"
                            />
                            <img
                                v-if="infomaterial.infomaterial_item.infomaterial_item_thumbnail_992x285"
                                :alt="infomaterial.infomaterial_item.infomaterial_item_title"
                                class="infomaterial-item-thumbnail-992-285"
                                :src="infomaterial.infomaterial_item.infomaterial_item_thumbnail_992x285"
                            />
                        </div>
                        <div class="infomaterial-item-content-container p-3 py-md-4">
                            <p class="infomaterial-item-title font-weight-bold text-uppercase"
                               v-html="infomaterial.infomaterial_item.infomaterial_item_title"></p>
                            <h3 class="infomaterial-item-heading font-weight-bold text-uppercase"
                                v-html="infomaterial.infomaterial_item.infomaterial_item_heading"></h3>
                            <p class="infomaterial-item-description"
                               v-html="infomaterial.infomaterial_item.infomaterial_item_description"></p>
                            <div class="btn-container"
                                 v-if="infomaterial.infomaterial_item.infomaterial_item_downloadable.infomaterial_item_downloadable_file || infomaterial.infomaterial_item.infomaterial_item_order_button_text">
                                <a target="_blank" class="btn btn-black-white"
                                   v-if="infomaterial.infomaterial_item.infomaterial_item_downloadable"
                                   :href="infomaterial.infomaterial_item.infomaterial_item_downloadable.infomaterial_item_downloadable_file">
                                    <span v-html="infomaterial.infomaterial_item.infomaterial_item_downloadable.infomaterial_item_downloadable_button_text ? infomaterial.infomaterial_item.infomaterial_item_downloadable.infomaterial_item_downloadable_button_text : 'PDF herunterladen'"></span>
                                    <i class="arrow arrow-down"></i>
                                </a>
                                <a class="btn btn-pink-white"
                                   v-if="infomaterial.infomaterial_item.infomaterial_item_order_button.infomaterial_item_order_button_link"
                                   @click='loadContactForm(infomaterial.infomaterial_item.infomaterial_item_order_button.infomaterial_item_order_button_link)'
                                   v-html="(infomaterial.infomaterial_item.infomaterial_item_order_button.infomaterial_item_order_button_link ? infomaterial.infomaterial_item.infomaterial_item_order_button.infomaterial_item_order_button_text : 'Bestellen') + '<i class=\'arrow arrow-right\'></i>'">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bestellformular-content"
             v-show="showContactForm !== false && page.content && page.content.rendered">
            <div class="container-fluid">
                <div class="bestellformular-content-inner"
                     v-html="page.content && page.content.rendered"
                     ref="contactForm"></div>
            </div>
        </div>

    </main>

</template>

<script>

// console.log('Glossary');

import env from '../env';

import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

import wpApi from '../services/wpApi';

export default {
    mixins : [smoothReflow],
    created(){
        this.load();
        this.$root.states.pageIsShown = true;
    },
    mounted(){
        this.$smoothReflow({
            transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
        });
    },
    components : {},
    computed : {},
    data(){
        return {
            page : {
                acf : {},
                link : '',
                title : {},
            },
            showContactForm : false,
            wpApi,
        };
    },
    props : {},
    metaInfo(){
        return {
            meta : [
                {
                    vmid : 'description',
                    name : 'description',
                    content : this.page['acf']['meta_description'],
                },
                {
                    vmid : 'og:description',
                    property : 'og:description',
                    content : this.page['acf']['meta_og_description'],
                },
                {
                    vmid : 'og:image',
                    property : 'og:image',
                    content : this.page['acf']['meta_og_image_1200_630'],
                },
                {
                    vmid : 'og:image:alt',
                    property : 'og:image:alt',
                    content : this.page['acf']['meta_og_image_alt_text'],
                },
                {
                    vmid : 'og:title',
                    property : 'og:title',
                    content : this.page['acf']['meta_og_title'],
                },
                {
                    vmid : 'og:url',
                    property : 'og:url',
                    content : this.page['link'],
                },
            ],
            title : this.page['title']['rendered'],
        };
    },
    methods : {
        load(){

            wpApi.http.get(wpApi.host + wpApi.baseUrl + '/wp-json/wp/v2/pages?slug=infomaterialien')
                .then(response=>{

                    this.page = response.data[0];

                    // Add a native event listener to the Vue element.
                    //this.$el.addEventListener("click", this.onHtmlClick)

                    window.setTimeout(()=>{

                        // this.$ga.page(this.$route.fullPath);
                        this.$gtm.trackEvent({
                            event : 'Pageview',
                            url : this.$route.path.toLowerCase().replace(/\/$/, ""),
                        });
                    });
                })
                .catch(error=>{
                    console.log('error', error);
                    // this.$router.push('/404');
                });
        },
        loadContactForm(query){

            this.showContactForm = true;

            let rootSelector = '.bestellformular-content-inner';
            let $form = this.$el.querySelector(rootSelector + ' form');
            let $checkboxSelector = rootSelector + ' input[type="checkbox"]';

            if (query.length > 2 && query.includes("=")
                && this.$el.querySelectorAll($checkboxSelector).length > 0) {

                query = query.split("?")[0];
                let queryParams = query.split("&");

                if (queryParams.length > 0) {
                    queryParams.forEach((queryParam, i)=>{

                        let keyValue = queryParam.split("=");

                        if (keyValue.length == 2) {
                            this.$el.querySelector($checkboxSelector + '[name="' + keyValue[0] + '"][value="' + keyValue[1] + '"]').checked = true;
                        }
                    });
                }
            }

            $form.querySelectorAll('input[required], input.required').forEach($inputField=>{

                if ($inputField.type != 'checkbox') {
                    ['keyup', 'input', 'blur'].forEach(event=>{
                        $inputField.addEventListener(event, function(e){

                            if ($inputField.classList.contains("alert-danger")) {
                                $inputField.classList.remove("alert-danger");
                            }
                        });
                    });
                } else if ($inputField.closest(".form-check")) {

                    $inputField.addEventListener('change', function(e){
                        if ($inputField.closest(".form-check").classList.contains("alert-danger")) {
                            $inputField.closest(".form-check").classList.remove("alert-danger")
                        }
                    });

                }
            });


            let $requiredCheckBoxes = $form.querySelectorAll('.wpcf7-checkbox.wpcf7-validates-as-required');
            if ($requiredCheckBoxes.length) {
                $requiredCheckBoxes.forEach($requiredCheckBox=>{
                    if ($requiredCheckBox.querySelector('input[type="checkbox"]')) {
                        $requiredCheckBox.querySelector('input[type="checkbox"]').addEventListener('change', function(e){
                            if ($requiredCheckBox.classList.contains("alert-danger")) {
                                $requiredCheckBox.classList.remove("alert-danger")
                            }
                        });
                    }
                });
            }

            $form.addEventListener('submit', function(e){

                e.preventDefault();

                let formData = new FormData($form);
                let formID = formData.get('_wpcf7'),
                    $formSubmitButton = $form.querySelector('input[type=submit]'),
                    $formResContainer = $form.querySelector('.wpcf7-response-output'),
                    isFormValidated = true;

                const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                const postalCodeRegex = /^\d{5}$/;
                const straseHausnummerRegex = /^([\S\s]+?)\s+([\d-]*)\s*([\w])?$/gm;

                $form.querySelectorAll('input[required], input.required').forEach($inputField=>{

                    if ($inputField.type != 'checkbox') {

                        if ($inputField.value.length == 0 ||
                            ($inputField.type == 'email' && !emailRegex.test(String($inputField.value).toLowerCase())) ||
                            ($inputField.classList.contains("postal-code") && !postalCodeRegex.test($inputField.value)) ||
                            ($inputField.classList.contains("strase-hausnummer") && !straseHausnummerRegex.test($inputField.value))) {
                            isFormValidated = false;
                            $inputField.classList.add("alert-danger");
                        } else if ($inputField.classList.contains("alert-danger")) {
                            $inputField.classList.remove("alert-danger");
                        }

                    } else if ($inputField.closest(".form-check")) {

                        if ($inputField.checked == false) {
                            isFormValidated = false;
                            $inputField.closest(".form-check").classList.add("alert-danger");
                        } else if ($inputField.closest(".form-check").classList.contains("alert-danger")) {
                            $inputField.closest(".form-check").classList.remove("alert-danger");
                        }
                    }

                });

                let $requiredCheckBoxes = $form.querySelectorAll('.wpcf7-checkbox.wpcf7-validates-as-required');
                if ($requiredCheckBoxes.length) {

                    $requiredCheckBoxes.forEach($requiredCheckBox=>{

                        let $checkboxInput = $requiredCheckBox.querySelector('input[type="checkbox"]');
                        if ($checkboxInput != null) {
                            if ($requiredCheckBox.querySelectorAll('input[name="' + $checkboxInput.name + '"]:checked').length == 0) {
                                isFormValidated = false;
                                $requiredCheckBox.classList.add("alert-danger");
                            } else if ($requiredCheckBox.classList.contains("alert-danger")) {
                                $requiredCheckBox.classList.remove("alert-danger");
                            }
                        }

                    });
                }

                if (isFormValidated == false) {
                    $formResContainer.innerHTML = 'Bitte ergänze die fehlenden Angaben, um die Bestellung abzuschließen.';
                    $formResContainer.classList.add("p-3");
                    $formResContainer.classList.add("alert-danger");
                    $formResContainer.focus();
                    return isFormValidated;
                }

                $formSubmitButton.disabled = true;
                $formResContainer.innerHTML = '';
                $formResContainer.classList.remove("p-3");
                $formResContainer.classList.remove("alert-success");
                $formResContainer.classList.remove("alert-danger");

                if (formID != null) {

                    wpApi.http.post(wpApi.host + wpApi.baseUrl + '/wp-json/contact-form-7/v1/contact-forms/' + formID + '/feedback',
                        formData, { headers : { 'X-Cache' : false } })
                        .then(response=>{

                            $formResContainer.classList.add("p-3");
                            $formResContainer.focus();
                            $formResContainer.innerHTML = response.data.message;

                            if (response.data.status === "mail_sent") {

                                $formResContainer.classList.add("alert-success");
                                $form.reset();
                                $form.querySelectorAll('.alert-danger').forEach($inputField=>{
                                    $inputField.classList.remove("alert-danger");
                                });

                            } else {

                                $formResContainer.classList.add("alert-danger");
                                if (response.data.hasOwnProperty('invalid_fields')
                                    && response.data.invalid_fields.length > 0) {

                                    response.data.invalid_fields.forEach(invalidField=>{

                                        if ($form.querySelector(invalidField.into + ' input[type="text"]') != null) {
                                            $form.querySelector(invalidField.into + ' input[type="text"]').classList.add("alert-danger");
                                        } else if ($form.querySelector(invalidField.into + ' input[type="email"]') != null) {
                                            $form.querySelector(invalidField.into + ' input[type="email"]').classList.add("alert-danger");
                                        } else if ($form.querySelector(invalidField.into + ' .wpcf7-checkbox') != null) {
                                            $form.querySelector(invalidField.into + ' .wpcf7-checkbox').classList.add("alert-danger");
                                        }

                                    });
                                }
                            }

                            // Add a native event listener to the Vue element.
                            //this.$el.addEventListener("click", this.onHtmlClick)
                        })
                        .catch(error=>{
                            console.log('error', error);
                            // this.$router.push('/404');
                        })
                        .finally(()=>{
                            $formSubmitButton.disabled = false;
                        });

                }

            }, false);

            window.scrollTo(0, 0);
        },
    },
}

</script>

<style lang="scss">

@import '../../css/variables';

.page-header {
    .heading-container {
        margin-bottom: 30px;
        @media (min-width: 768px) {
            margin-bottom: 60px;
        }
        .heading-container-inner {
            position: relative;
            height: 258px;
            @media (min-width: 576px) {
                height: 480px;
            }
        }
        .image-copyright-text {
            opacity: 0.4;
            font-size: 10px;
            margin: 15px auto 0;
            padding-left: 15px;
            padding-right: 15px;
            text-align: right;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
            -o-user-select: none;
            user-select: none;
            @media (min-width: 768px) {
                font-size: 12px;
            }
        }
    }
    .image-container {
        background-color: rgba(0, 0, 0, 0.25);
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        height: 258px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        &.d-sm-block {
            height: 480px;
        }
    }
    .overlay {
        background-color: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .heading {
        font-size: 27px;
        font-weight: bold;
        line-height: 1.2;
        color: $color-nochvielvor-white;
        text-transform: uppercase;
        position: absolute;
        left: 24px;
        right: 24px;
        bottom: 30px;
        word-wrap: break-word;
        @media (min-width: 576px) {
            max-height: 480px;
            left: 34px;
            right: 34px;
            top: 210px;
            font-size: 30px;
            line-height: 1.33;
        }
    }

    .sub-heading {
        font-size: 27px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: $color-nochvielvor-black;
        margin-bottom: 24px;
        @media screen and (min-width: 768px) {
            font-size: 30px;
            line-height: 1.33;
            margin-bottom: 30px;
        }
    }

    .short-text {
        font-size: 12px;
        line-height: 1.6;
        color: $color-nochvielvor-black;
        @media (min-width: 768px) {
            font-size: 18px;
            line-height: 1.33;
            text-align: left;
            color: #2b2e34;
            margin-right: 25%;
        }
    }

    .page-details {
        padding-left: 9px;
        padding-right: 9px;
        margin-bottom: 30px;
        @media (min-width: 576px) {
            padding-left: 19px;
            padding-right: 19px;
        }
        @media (min-width: 768px) {
            margin-bottom: 60px;
        }
    }
}

.arrow {
    border-style: solid;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    margin-left: 10px;
}

.arrow-down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    margin-bottom: 3px;
}

.arrow-right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin-bottom: 1px;
}

.btn.btn-black-white {
    i.arrow {
        border-color: $color-nochvielvor-white;
    }
    &:hover {
        i.arrow {
            border-color: inherit;
        }
    }
}

.infomaterial-container {
    background-color: $color-nochvielvor-pink;
    padding-top: 30px;
    padding-bottom: 30px;
    .infomaterial-inner {
        padding-left: 9px;
        padding-right: 9px;
        @media (min-width: 576px) {
            padding-left: 19px;
            padding-right: 19px;
        }
    }
    .infomaterial-item {
        background-color: $color-nochvielvor-white;
        width: 100%;
        @media (min-width: 768px) {
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        }
        &:not(:first-child) {
            margin-top: 30px;
        }
        &:not(:last-child) {
            margin-bottom: 30px;
        }
        &::after {
            display: block;
            clear: both;
            content: "";
        }
        .infomaterial-item-thumbnail-container, .infomaterial-item-content-container {
            width: 100%;
            @media (min-width: 768px) {
                position: relative;
            }
        }
        .infomaterial-item-thumbnail {
            max-width: 100%;
            height: auto;
            display: none;
        }
        .infomaterial-item-thumbnail-992-285 {
            max-height: 285px;
            width: 100%;
        }
        @media (min-width: 992px) {
            .infomaterial-item-thumbnail-container {
                -ms-flex: 0 0 41.666667%;
                flex: 0 0 41.666667%;
                max-width: 41.666667%;
            }
            .infomaterial-item-thumbnail {
                display: block;
            }
            .infomaterial-item-thumbnail-992-285 {
                display: none;
            }
            .infomaterial-item-content-container {
                -ms-flex: 0 0 58.333333%;
                flex: 0 0 58.333333%;
                max-width: 58.333333%;
                text-align: center;
            }
            .btn-container {
                position: absolute;
                margin-left: auto;
                margin-right: auto;
                width: 100%;
                bottom: 30px;
            }
        }
        @media (min-width: 1440px) {
            .infomaterial-item-title {
                font-size: 20px;
                margin-bottom: 20px;
            }
            .infomaterial-item-heading {
                margin-bottom: 20px;
                padding-left: 120px;
                padding-right: 120px;
            }
            .infomaterial-item-description {
                font-size: 20px;
                margin-left: 40px;
                margin-right: 40px;
            }
        }
        @media (max-width: 1200px) {
            .infomaterial-item-title {
                font-size: 16px;
            }
            .infomaterial-item-heading {
                font-size: 18px;
            }
            .infomaterial-item-description {
                font-size: 12px;
            }
        }
        @media (max-width: 575.98px) {
            .infomaterial-item-thumbnail {
                display: block;
            }
            .infomaterial-item-thumbnail-992-285 {
                display: none;
            }
            .btn-container .btn {
                margin-top: 10px;
            }
        }
    }
}

.bestellformular-content {
    padding-bottom: 30px;
    padding-top: 20px;
    @media (min-width: 992px) {
        padding-top: 30px;
    }
    .bestellformular-content-inner {
        padding-left: 17px;
        padding-right: 17px;
        h2 {
            margin-bottom: 30px;
            word-wrap: break-word;
            @media (max-width: 991.98px) {
                font-size: 1.75rem;
            }
            @media (max-width: 767.98px) {
                font-size: 1.25rem;
            }
            @media (max-width: 359.98px) {
                font-size: 1rem;
            }
            @media (max-width: 279.98px) {
                font-size: 0.90rem;
            }
        }
        label {
            width: 100%;
        }
        .infomaterial-checkbox-container {
            margin-bottom: 50px;
        }
        .form-check {
            padding-left: 0;
            label {
                cursor: pointer;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }
            input[type="checkbox"] {
                display: none;
                & + span {
                    background-repeat: no-repeat;
                    background-position-x: left;
                    background-repeat: no-repeat;
                    background-image: url("/img/ic_checkbox.png");
                    height: 22px;
                    display: inline-block;
                    padding-left: 35px;
                }
                &:not(:checked) + span {
                    background-position-y: bottom;
                }
                &:checked + span {
                    background-position-y: top;
                }
            }
        }
        .form-control {
            border-width: 2px;
            border-color: #000000;
            border-radius: 0;
        }
        .wpcf7-checkbox, .wpcf7-acceptance {
            span.wpcf7-list-item {
                display: block;
                clear: both;
            }
        }
        .wpcf7-checkbox {
            display: block;
            span.wpcf7-list-item .wpcf7-list-item-label {
                line-height: 1.5;
            }
        }
        .wpcf7-acceptance span.wpcf7-list-item .wpcf7-list-item-label {
            font-size: 12px;
        }
        .form-group .wpcf7-form-control-wrap {
            margin-top: 8px;
            display: block;
        }
        .form-description-text {
            margin-top: 50px;
            font-size: 18px;
            line-height: 28px;
        }
        .submit-btn-container {
            position: relative;
            color: $color-nochvielvor-white;
            &:after {
                content: "";
                position: absolute;
                border-style: solid;
                border-width: 0 3px 3px 0;
                display: inline-block;
                padding: 3px;
                top: 50%;
                margin-top: -6px;
                right: 20px;
                transform: rotate(-45deg);
                -webkit-transform: rotate(-45deg);
            }
            &:hover {
                color: $color-nochvielvor-pink;
            }
        }
        .wpcf7-submit {
            padding-bottom: 0.75rem;
            padding-top: 0.75rem;
        }
        .form-acceptance {
            .wpcf7-list-item-label {
                text-indent: -9999px;
            }
            .acceptance-label {
                margin-left: 35px;
                display: inline-block;
                margin-top: -30px;
            }
        }
        @media (min-width: 992px) {
            margin-right: auto;
            margin-left: auto;
            width: 50%;
            .wpcf7-form {
                h2, p {
                    width: 100%;
                }
                p .wpcf7-form-control-wrap {
                    margin-bottom: 15px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// public/js/components/Infomaterialien.vue